import type { ContactInfo } from '@/data/types';
import contactData from '@/data/contact.json';

export function useContactData() {
  const contactInfo = contactData as ContactInfo;
  return { contactInfo, loading: false, error: null };
}